module.exports = __webpack_public_path__ + "assets/img/t3.0ffdc9bc.png";